import { Component, Emit, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
@Component({})
export default class TopmenuTrackMixin extends Vue {
  public trackMenu(moduleName: string) {
    window['sensors'].track('TIKU_mainNavigation_clk', { moduleName })
  }
}
